import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['current_user']),
  },
  methods: {
    checkAuth() {
      if (!this.current_user.user.firstname) {
        this.logoutUser();
      }
    },
    logoutUser() {
      this.$emit('close');
      this.$store
        .dispatch('logoutUser')
        .then(() => this.$router.push({ name: 'login' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido desconectar tu cuenta',
          });
        });
    },
  },
};
